import { useGoogleLogin } from '@react-oauth/google';

const Login = ({setUser}) => {

	const login = useGoogleLogin({
		onSuccess:  async tokenResponse => {
			const token = tokenResponse.access_token;
			window.reqServer("/user/login/google", "get", { token, notificationToken: null, theme: 1 }, (user)=> {
				if(user == null || user.error)
					alert(user?.error);
				else {
					window.setData("loginToken", user.loginToken);
					setUser(user);
				}
			})
		},
		onError: (error) => console.log('Login Failed:', error),
	});

	return <div style={{justifyContent: "center", display: "flex"}}>
		<button onClick={login} className="btn1">
			<span style={{display: "flex", alignItems: "center", gap: 10}}>
				<img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/2048px-Google_%22G%22_logo.svg.png"
					style={{width:40,height:40}} alt=""
				/>
				Login with google
			</span>
		</button>
	</div>
}

export default Login;